export default __webpack_public_path__ + "static/media/nellaheadshot1.7d2a86de.jpg";